class ClickAvoidPropagation {
    constructor() {
        this._init()
    }
    _init() {
        this.els = document.querySelectorAll('[data-avoid-propagation]').forEach(el => {
            el.addEventListener('click', e => e.stopPropagation())
        })
    }
}

export default ClickAvoidPropagation